<template>
  <header class="blog-header">
    <div class="container">
      <div class="row d-flex justify-content-center">
        <div class="col-6 text-center">
          <template v-if="blog">
            <img v-if="blog.upload && blog.upload.path" class="blog-header__logo" :src="blog.upload.path" alt="Blog Logo" />
            <img v-else class="blog-header__logo" :src="logo" alt="Blog Logo" />
            <h1 class="blog-header__title mt-2 mb-0">{{blog.title}}</h1>
          </template>

          <h1 v-else class="blog-header__title mt-2 mb-0">{{altText ? altText : 'Loading Blog...'}}</h1>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Logo from '@/assets/avatar-circle.png'

export default {
  name: 'BlogHeader',
  props: ["blog", "altText"],
	data() {
		return {
			logo: Logo
		}
  }
}
</script>

<style lang="scss" scopes>
.blog-header {
  background: #14264d;
  color: #fff;
  padding: 60px 0;
  &__title {
    font-size: 24px;
  }
  &__logo {
    border: 4px solid #fff;
    border-radius: 100%;
    height: 100px;
    width: 100px;
  }
}
</style>